module.exports = __webpack_public_path__ + "img/Butterfly_00202.da402328.png";